import { render, staticRenderFns } from "./AdminBookings.vue?vue&type=template&id=56a2ff30&scoped=true&"
import script from "./AdminBookings.vue?vue&type=script&lang=js&"
export * from "./AdminBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2ff30",
  null
  
)

export default component.exports